module.exports = __webpack_public_path__ + "static/media/free_box_mockup_1.dbef4fa5.png";